import React, {FC, useEffect} from 'react';
import classes from './ReportsTabBar.module.scss';
import {useSearchParams} from "react-router-dom";
import {useAppSelector} from "../../../shared/hooks/useAppSelector";
import {TeacherRole} from "../../../shared/types/teacher";

export enum ReportType {
    PAYMENTS = 'PAYMENTS',
    FEW_AVAILABLE_LESSONS = 'FEW_AVAILABLE_LESSONS'
}

const tabs = [
    {
        type: ReportType.PAYMENTS,
        label: 'Платежи',
    },
    {
        type: ReportType.FEW_AVAILABLE_LESSONS,
        label: 'Малый остаток уроков',
        availableRoles: [TeacherRole.ADMIN]
    },

];


const ReportsTabBar: FC = () => {
    const currentTeacher = useAppSelector(state => state.auth.currentTeacher)
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setSearchParams({type: ReportType.PAYMENTS})
    }, []);

    const updateTab = (type: ReportType) => setSearchParams({type})

    return (
        <div className={classes.tabBar}>
            {
                tabs
                    .filter(tab =>
                        !tab.availableRoles ||
                        (currentTeacher?.role && tab.availableRoles.includes(currentTeacher?.role))
                    )
                    .map(tab =>
                        <div
                            key={tab.type}
                            className={`${classes.tab} ${searchParams.get('type') === tab.type ? classes.active : ''}`}
                            onClick={() => {
                                updateTab(tab.type)
                            }}
                        >
                            {tab.label}
                        </div>
                    )
            }
        </div>
    );
};

export default ReportsTabBar;